import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import "./CantSee.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";
import { useCareersSection } from "../../../../context/CareersPageContext";
import { resolveMediaUrl } from "../../../../utils/resolveMediaUrl";

const CantSee = () => {
  const { section, loading } = useCareersSection("cant-see");

  const bgSrc = useMemo(() => {
    const url = section?.media?.primary?.url;
    return url ? resolveMediaUrl(url) : "";
  }, [section]);

  if (loading || !section?.fields) return null;

  const fields = section.fields;

  return (
    <section className="extra">
      <div className="extra-card">
        {bgSrc ? <img src={bgSrc} alt="" className="extra-bg" /> : null}

        {fields.title ? (
          <CmsText content={fields.title} as="h2" />
        ) : null}
        {fields.description ? (
          <RichTextContent content={fields.description} />
        ) : null}

        {fields.button_link ? (
          <Link to={fields.button_link} className="buttonclip extra-btn">
            <CmsText content={fields.button_text || "Contact Us"} as="span" />
          </Link>
        ) : null}
      </div>
    </section>
  );
};

export default CantSee;
